import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import { Icon } from '@wordpress/components';
import { symbol} from '@wordpress/icons';


registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson},
	edit: Edit,
	icon: <Icon icon={symbol}  style={{color:'#6c1bc3'}} />,
	save,
} );